export default __webpack_public_path__ + "static/media/image table.25f65ac5.jpeg";